type AnalyticsData = Record<string, string | number | boolean>;

declare global {
  interface Window {
    umami?: { track(name: string, data?: AnalyticsData): void | Promise<unknown> };
  }
}

/** First-party custom events only. Pageviews belong to the injected tracker.
 * Pass fixed UI dimensions, never URLs, attribution cookies or user input. */
export function trackEvent(name: string, data?: AnalyticsData): void {
  if (typeof window === "undefined") return;
  try {
    void Promise.resolve(window.umami?.track(name, data)).catch(() => {});
  } catch { /* Measurement must never interrupt navigation. */ }
}

export function trackSignupCta(location: "hero" | "floating" | "footer" | "navigation"): void {
  trackEvent("signup_cta_clicked", { location, surface: "homepage" });
}
